import http from './http';

// 查询筛选项
export const getFilterConfig = () => {
  return http({
    method: 'GET',
    url: '/rooms/filter',
  });
};

// 查询实时房态列表
export const getRealtimeState = (data) => {
  return http({
    method: 'POST',
    url: '/rooms/realtime',
    data,
  });
};

// 查询房间电脑状态
export const getComputerByRoom = (data) => {
  return http({
    method: 'POST',
    url: '/computers/machine/query-computers',
    data,
  });
};

// 房间置脏
export const setRoomToDirty = (data) => {
  return http({
    method: 'POST',
    url: '/rooms/status/dirty',
    data,
  });
};

// 房间置净
export const setRoomToClean = (data) => {
  return http({
    method: 'POST',
    url: '/rooms/status/clean',
    data,
  });
};

// 获取清洁人员列表
export const getCleanerList = () => {
  return http({
    method: 'GET',
    url: '/employee/cleaners',
  });
};

// 获取房间详情
export const getRoomDetail = (data) => {
  return http({
    method: 'GET',
    url: '/rooms/detail',
    params: data,
  });
};

// 房间启用
export const setRoomToEnable = (data) => {
  return http({
    method: 'POST',
    url: '/rooms/status/enable',
    data,
  });
};

// 房间停用信息
export const getRoomsStatusDisableInfo = (params: { roomId: number; date: number }) => {
  return http({
    method: 'POST',
    url: '/rooms/disable-info',
    data: params,
  });
};

// 房间禁用
export const setRoomToDisable = (data) => {
  return http({
    method: 'POST',
    url: '/rooms/status/disable',
    data,
  });
};

// 房间禁用编辑
export const updateRoomDisable = (data) => {
  return http({
    method: 'POST',
    url: '/rooms/status/disable/update',
    data,
  });
};

// 房态日历
export const getRoomCalendar = (data) => {
  return http({
    method: 'POST',
    url: '/rooms/calendar',
    data,
  });
};

// 子单详情
export const getSubOrderDetail = (data) => {
  return http({
    method: 'GET',
    url: '/sub/order/rec',
    params: data,
  });
};

// 远期房态
export const getFutureRoomData = (data) => {
  return http({
    method: 'POST',
    url: '/rooms/future-list',
    data,
  });
};

// 通知打扫
export const noticeCleanRoom = (roomId) => {
  return http({
    method: 'POST',
    url: `/rooms/status/${roomId}/notice`,
  });
};

// 获取房间钟点房列表
export const getTimeRentRecord = (data) => {
  return http({
    method: 'POST',
    url: '/sub/order/list-time-rent',
    data,
  });
};

// 获取异常提醒规则列表
export const getAlertRuleList = () => {
  return http({
    method: 'GET',
    url: '/alert/shop',
  });
};

// 新增编辑异常提醒规则
export const updateAlertRuleItem = (data) => {
  return http({
    method: 'POST',
    url: '/alert/rules',
    data,
  });
};

// 删除异常提醒规则
export const deleteAlertRuleItem = (params) => {
  return http({
    method: 'DELETE',
    url: '/alert/rules/delete',
    params,
  });
};
